/* code copyright 2025 (c) Tuva Labs Inc.
 *
 * created by nganesan
 */
import AttributeView from "./AttributeView";
import CardView from "./CardView";

export class ElemEditableView {
    constructor(Dyn, container) {
        this.Dyn = Dyn;
        this.attributeView = new AttributeView(Dyn, container);
        this.cardView = new CardView(Dyn, container);
    }

    destroy() {
        this.attributeView.destroy();
        this.cardView.destroy();
    }

    initVisuals() {
        this.attributeView.initVisuals();
        this.cardView.initVisuals();
    }

    updateVisuals(caseIndex) {
        this.attributeView.updateVisuals();
        this.cardView.updateVisuals(caseIndex);
    }

    resize(newSize, inPlotBounds) {
        this.attributeView.resize(newSize, inPlotBounds);
        this.cardView.resize(newSize, inPlotBounds);
    }

    saveEditState() {
        return {
            isEditing: true,
            // add more editable state here, if any, for restore
        };
    }

    restoreEditState( saveData) {
        // restore any editable state here
        this.Dyn.assert( saveData.isEditing, "expected isEditing");
    }

    showCardView() {
        this.cardView.show();
    }

    hideCardView() {
        this.cardView.hide();
    }

    showAttributeView() {
        this.attributeView.show();
    }

    hideAttributeView() {
        this.attributeView.hide();
    }
}
